import { render, staticRenderFns } from "./PeripheralGoods.vue?vue&type=template&id=6678778c&scoped=true&"
import script from "./PeripheralGoods.vue?vue&type=script&lang=ts&"
export * from "./PeripheralGoods.vue?vue&type=script&lang=ts&"
import style0 from "./PeripheralGoods.vue?vue&type=style&index=0&id=6678778c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6678778c",
  null
  
)

export default component.exports